import EntityChallengeEdit from './EntityChallengeEdit';

export default EntityChallengeEdit;
